var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState, useCallback } from 'react';
import { InputBase, IconContainer, TextContainer } from '../components';
import { usePipe } from './usePipe';
import { useMask } from './useMask';
export const InputPipeMask = _a => {
  var {
    rightIcon24,
    leftIcon24,
    rightText,
    size,
    value,
    setRef,
    mask,
    pipeIn
  } = _a,
      rest = __rest(_a, ["rightIcon24", "leftIcon24", "rightText", "size", "value", "setRef", "mask", "pipeIn"]);

  const [ref, setRefInput] = useState(null);
  const setRefLocal = useCallback(node => {
    setRefInput(node);
    setRef && setRef(node);
  }, []);
  useMask({
    mask,
    ref
  });
  const valueNew = usePipe({
    pipe: pipeIn,
    value,
    ref
  });
  const leftNode = leftIcon24 && React.createElement(IconContainer, {
    size: size
  }, leftIcon24);
  let rightNode = rightIcon24 && React.createElement(IconContainer, {
    size: size
  }, rightIcon24);
  rightNode = rightText ? React.createElement(TextContainer, {
    size: size
  }, rightText) : rightNode;
  return React.createElement(InputBase, Object.assign({
    size: size,
    leftNode: leftNode,
    rightNode: rightNode,
    value: valueNew,
    setRef: setRefLocal
  }, rest));
};